<div class="agpr-formField" role="group" [attr.aria-labelledby]="field.headingId">
    <div
        *ngIf="field.label"
        class="agpr-formField-label agpr-colorCheckboxesContainer-heading"
    >
        {{ field.label | localize }}
    </div>
    <ul>
        <li *ngFor="let fieldOption of filteredOptions; let i = index">
            <div
                class="agpr-colorCheckboxesContainer"
                role="group"
                [attr.aria-label]="fieldOption.label | localize"
            >
                <agpr-checkbox
                    [id]="id + '_color-checkboxes_' + i"
                    [(ngModel)]="value"
                    [value]="fieldOption.key"
                    [label]="fieldOption.label"
                    [disabled]="fieldOption.disabled"
                    name="colorCheckboxesOptions"
                    [binary]="field.binary"
                    [infoCircleTooltip]="fieldOption.tooltip"
                    (ngModelChange)="handleChanges($event)"
                >
                </agpr-checkbox>
                <div class="agpr-colorCheckboxesContainer-colorPickerFieldContainer">
                    <agpr-color-picker-field
                        [id]="id + '.colorPickerField_' + i"
                        [config]="{
                            showRecentColors: true,
                            disabled: !valueMap[fieldOption.key],
                            ariaLabel: 'Reports.formfield.metadata.colorSelection'
                        }"
                        [value]="block?.displayElement?.styles?.colorMap[fieldOption.key]"
                        (changes)="handleColorChange($event, fieldOption.key)"
                    ></agpr-color-picker-field>
                </div>
            </div>
        </li>
    </ul>
    <agpr-form-message *ngIf="field.errorMessage && !this.value?.length">
        {{ field.errorMessage | localize }}
    </agpr-form-message>
    <div
        *ngIf="field.description"
        class="agpr-formField-description"
    >
        {{ field.description | localize }}
    </div>
</div>
